import { useQuery } from '@tanstack/react-query';
import type { UserWithRelatives } from '../../models/users/user-with-relatives.dto';
import apiRequest from '../../services/apiWrapper';
import { USERS_URL } from '../../utils/constants/urlConstants';

async function fetchUsersRelatives(
  ids: string[],
  areArchived: boolean
): Promise<UserWithRelatives[]> {
  const userIds = ids.join('&ids=');

  const response = await apiRequest.get<UserWithRelatives[]>(
    `${USERS_URL}/relatives?ids=${userIds}&areArchived=${areArchived}`
  );

  return response.data;
}

export function useGetUsersRelatives(ids: string[], areArchived: boolean) {
  return useQuery({
    queryKey: ['users-relatives', ids.join('&')],
    queryFn: () => fetchUsersRelatives(ids, areArchived),
  });
}
